// CSP-safe placeholder formatter: replaces {0}, {1}, ... with provided args.
export function fmt(tpl, ...args) {
  const s = tpl == null ? '' : String(tpl);
  return s.replace(/\{(\d+)\}/g, (_, i) => {
    const idx = Number(i);
    return args[idx] != null ? String(args[idx]) : '';
  });
}